import { fork, takeEvery, takeLatest } from "redux-saga/effects";

import BusinessConstants from "modules/business/constants";
import BusinessSagas from "modules/business/sagas";
import BusinessActions from "modules/business/actions";

function* watchGetBusinessAccount() {
  yield takeEvery(BusinessActions.getBusinessAccount, BusinessSagas.getBusinessAccount);
}

export default [fork(watchGetBusinessAccount)];
